import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

import { withDeleteReport } from './../../../shared/containers/containerDeleteReport'
import { states } from '../../../reducers/queriesStates';

const DeleteSavedReportBtn = props => {
  const { deleteReportDataState, deleteReportId, onDeleteReport, itemId } = props

  return (
    deleteReportDataState === states.REQUEST && deleteReportId === itemId
      ? <CircularProgress />
      : <span className="icon-x" onClick={onDeleteReport.bind(this, itemId)}></span>
  )
}

export default withDeleteReport(React.memo(DeleteSavedReportBtn))